module.exports = __webpack_public_path__ + "img/20190814161104898.f239f2d6.png";